import {
    FaArrowsRotate,
    FaArrowsUpDownLeftRight,
    FaBolt,
    FaChartLine,
    FaCircleCheck,
    FaCloud,
    FaCrosshairs,
    FaGaugeHigh,
    FaHospital,
    FaLayerGroup,
    FaLock,
    FaMagnifyingGlass,
    FaMicroscope,
    FaSackDollar,
    FaShieldHalved,
    FaShieldHeart,
    FaStethoscope,
    FaSyringe,
    FaUserCheck,
    FaUserDoctor
} from "react-icons/fa6";

export const section1Data = [
    {
        icon: FaLayerGroup,
        title: "Multi-Modality",
        description: "Support across medical imaging technologies",
    },
    {
        icon: FaShieldHeart,
        title: "Preventive Care",
        description: "Maintenance focused on dependable uptime",
    },
    {
        icon: FaBolt,
        title: "Fast Response",
        description: "Prompt help when equipment issues arise",
    },
    {
        icon: FaCircleCheck,
        title: "Quality Focused",
        description: "Careful testing, calibration, and service",
    },
    {
        icon: FaArrowsRotate,
        title: "Lifecycle Support",
        description: "Guidance from installation through upgrades",
    },
];

export const section3Data = [
    {
        icon: <FaCrosshairs />,
        title: "Clear Visual Guidance",
        description:
            "Provides clear imaging guidance for accurate needle placement, helping improve treatment precision and reduce patient discomfort.",
    },
    {
        icon: <FaArrowsUpDownLeftRight />,
        title: "Flexibility & Ease",
        description:
            "Its compact, portable design makes it easy to use across different clinical settings, including procedure rooms and operating rooms.",
    },
    {
        icon: <FaUserCheck />,
        title: "Better Patient Results",
        description:
            "Greater injection precision can mean fewer attempts, better treatment accuracy, and a more comfortable experience for patients.",
    },
    {
        icon: <FaShieldHalved />,
        title: "Safety",
        description:
            "Advanced imaging and radiation technology is designed to support effective procedures while helping minimize unnecessary exposure for patients and providers.",
    },
];

export const section4Data = [
    {
        icon: <FaMagnifyingGlass />,
        title: "Early Warning",
        description:
            "Detect blood vessel and ANS problems early to support proactive care.",
    },
    {
        icon: <FaCloud />,
        title: "Shared Cloud Platform",
        description:
            "Connect providers through CCS Cloud for easier collaboration and shared care.",
    },
    {
        icon: <FaLock />,
        title: "Secure Patient Area",
        description:
            "Give patients secure access to their health data while encouraging engagement.",
    },
    {
        icon: <FaGaugeHigh />,
        title: "Fast Results",
        description:
            "Three integrated devices deliver precise results in just a few minutes.",
    },
    {
        icon: <FaSackDollar />,
        title: "Fair Price",
        description:
            "Pricing covers equipment, technician, and billing costs, with monthly minimums applying.",
    },
];



export const proPrograms = [
    {
        id: 1,
        title: "Brain Zen Pro",
        description:
            "Its job is to recognize and correct conditions like ADHD, PTSD, and autism. It improves both the quality of patient care and your practice's financial health, all without any starting cost.",
        link: "/services/brain-zen-pro",
    },
    {
        id: 2,
        title: "Memory Care & Brain Brightening",
        description:
            "Old-age caregivers use neurofeedback to enhance memory care for senior citizens. Our Brain Brightening program enriches existing care initiatives.",
        link: "/services/brain-memory-care",
    },
];

export const featuresCardData = [
    {
        icon: <FaUserDoctor />,
        title: "Primary Care",
        description:
            "Improve patient care and your practice's efficiency. Use faster diagnostic tools and smoother workflows. This will increase outcomes and revenue.",
    },
    {
        icon: <FaStethoscope />,
        title: "Specialists",
        description:
            "Use our in-house solutions to speed up diagnosis and treatment. This will reduce reliance on outside sources and enhance patient satisfaction.",
    },
    {
        icon: <FaHospital />,
        title: "Large Healthcare Facilities",
        description:
            "We help large clinics and healthcare networks. Our tailored solutions ensure smooth operations, consistent support, and high-quality patient care.",
    },
];

export const stepper = [
    {
        icon: <FaChartLine />,
        title: "Fast Results",
        description:
            "Get clear allergy results faster for quicker treatment decisions.",
        align: "bottom",
    },
    {
        icon: <FaSyringe />,
        title: "Targeted Immunotherapy",
        description:
            "Personalized treatment based on each patient's allergy needs.",
        align: "top",
    },
    {
        icon: <FaMicroscope />,
        title: "Accurate Testing",
        description:
            "Identify allergy triggers with reliable, efficient testing.",
        align: "bottom",
        featured: true,
    },
    {
        icon: <FaShieldHeart />,
        title: "Simplified Insurance Coverage",
        description:
            "Simple allergy care that is easier to manage and understand.",
        align: "top",
    },
];

export const counterData = [
    {
        id: 1,
        value: 5,
        suffix: "+",
        label: "Years of Experience",
    },
    {
        id: 2,
        value: 20,
        suffix: "%",
        label: "Increased Revenue",
    },
    {
        id: 3,
        value: 100,
        suffix: "%",
        label: "HIPAA Compliance",
    },
    {
        id: 4,
        value: 80,
        suffix: "%",
        label: "Success Rate",
    },
];